import { DateTime } from 'luxon';
import { isEmptyType, isNotEmptyType, translateDynamicTimeRange } from '@/lib/filter/dynamic-date';

const isInRange = (timestamp, range) => {
  const { start, end } = translateDynamicTimeRange(range);

  const selected = DateTime.fromISO(timestamp);
  if (!selected.isValid) {
    return false;
  }

  const filters = [];
  if (start !== null) {
    const startDateTime = DateTime.fromISO(start);
    if (!startDateTime.isValid) {
      return false;
    }
    filters.push(selected > startDateTime);
  }
  if (end !== null) {
    const endDateTime = DateTime.fromISO(end);
    if (!endDateTime.isValid) {
      return false;
    }
    filters.push(selected < endDateTime);
  }
  if (filters.length === 0) {
    return false;
  }
  return filters.every((e) => e === true);
};

export const dateFn = ({ propertyValues, scope }) => {
  const neededValue = scope.timeRange;

  const value = propertyValues.find((pv) => pv.property.uid === scope.property.uid)?.timestamp;
  if (value === undefined) {
    return false;
  }
  if (isEmptyType(neededValue)) {
    return value === null;
  }
  if (isNotEmptyType(neededValue)) {
    return value !== null;
  }

  return isInRange(value, neededValue);
};

export const directDateFn = ({ entity, scope }) => {
  const neededValue = scope.timeRange;

  const value = entity[scope.directProperty.edgeName];
  if (value === undefined) {
    return false;
  }
  // FIXME: dateScope doesn't behave exactly like its siblings, some constructions consider the scope empty when timeRange.type === `dateScopeType.empty`
  if (scope.isEmpty || isEmptyType(neededValue)) {
    return value === null;
  }
  if (isNotEmptyType(neededValue)) {
    return value !== null;
  }

  return isInRange(value, neededValue);
};
